import { defaultConfig } from "config";

export default function useConfig() {
  return defaultConfig;
}